import { useBudgetUrl } from 'domain/shared/budget';
import { SidebarStickyMenu, SummaryMenuItem } from 'framework/ui/menu';

const ViewBudgetPageMenu = () => {
  const { getSingleEntityUrl } = useBudgetUrl();

  return (
    <SidebarStickyMenu>
      <SummaryMenuItem linkUrl={getSingleEntityUrl()} />
    </SidebarStickyMenu>
  );
};

export default ViewBudgetPageMenu;
